import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ChevronRightSmallFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ChevronRightSmallFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M12.21 7.5H8.48L11.8 12l-3.32 4.5h3.73l3.31-4.5-3.31-4.5Z" fill="currentColor" />
    </svg>;
}) as ForwardedIconComponent);
export default ChevronRightSmallFilled;